export default {
    header: {
        telefone: "Phone",
        signIn: "Sign In",
        register: "Register",
        becomeExpert: "Register your company",
        dashboard: "Dashboard",

        sidebar: {
            tuktuk: {
                title: "Tuk Tuk",
                subtitle: "Tuk Tuk Booking",
                menu: {
                    grid: "Tuk Tuk Grid",
                },
            },
            about: {
                title: "About",
                subtitle: "About",
                menu: {
                    aboutUs: "About Us",
                    testimonials: "Testimonials",
                    faq: "FAQ",
                    contact: "Contact Us",
                    terms: "Terms & Conditions",
                    privacy: "Privacy Policy",
                },
            },
            dashboard: {
                title: "Dashboard",
                subtitle: "User Dashboard",
                subtitle2: "Agent Dashboard",
                menu: {
                    dashboard: "Dashboard",
                    myBookings: "My Bookings",
                    reviews: "Reviews",
                    support: "Support",
                    wishlist: "Wishlist",
                    wallet: "Wallet",
                    profileSettings: "Profile Settings",
                    notifications: "Notifications",
                    myProfile: "My Profile",
                    settings: "Settings",
                    dashboard2: "Dashboard",
                    bookings: "Bookings",
                    enquiries: "Enquiries",
                    earnings: "Earnings",
                    reviews2: "Reviews",
                    settings2: "Settings",
                },
            },
            social: {
                title: "Social Network",
                subtitle: "Posts Feed",
                menu: {
                    feed: "Feed",
                    myProfilePage: "My Profile Page",
                    explore: "Explore",
                },
            },
        },
    },
    common: {
        welcome: "Welcome, {{name}}!",
    },
    home: {
        hero: {
            title: "Get Closer to the Dream:",
            title2: "Your Tour",
            title3: "Essentials Await",
            subtitle: "Your ultimate destination for everything that helps you celebrate and remember your tour experience.",
            tukTuk: "Tuk Tuk",
        },
        searchBy: {
            titlePrefix: "Packages",
            titleSuffix: "recent",
            subtitle:
                "Discover the most recently added packages on Portugalwaytour and explore unique travel opportunities carefully curated to provide you with unforgettable experiences, new destinations, and exclusive adventures around the world.",
            noPackages: "No recent packages found.",
            hasDiferencial: "Has differential",
            noReviews: "No reviews",
            viewAll: "View All Packages",
        },
        sectionBenefit: {
            titlePrefix: "Our",
            titleHighlight: "Benefits",
            titleSuffix: "and main advantages",
            subtitle:
                "Portugalway, a tour operator specializing in dream destinations, offers a variety of benefits for travelers.",
            benefits: [
                {
                    title: "Authentic Experiences",
                    description:
                        "Escape traditional tourism and discover authentic Portugal! Our tours provide genuine experiences exploring local culture, cuisine, and hidden spots.",
                },
                {
                    title: "Personalized Travel Packages",
                    description:
                        "Create your tailor-made trip! Choose your experience and we take care of everything: accommodation, transport, and activities for a personalized and unforgettable journey.",
                },
                {
                    title: "Comfort & Safety",
                    description:
                        "We take care of every detail: comfortable transport, selected accommodation, and professional guide support, ensuring peace of mind from start to finish.",
                },
                {
                    title: "Dedicated Support",
                    description:
                        "From first contact to the end of your trip, you have personalized support and a team ready to assist in Portuguese and English, with agility and full attention to your needs.",
                },
            ],
        },
        exploreCities: {
            title: "Explore by City",
            subtitle: "Discover unique experiences in amazing destinations",
        },
        placeSection: {
            titlePrefix: "Trending",
            titleHighlight: "Packages",
            subtitle:
                "Explore our most popular travel packages, carefully selected based on high ratings, positive reviews, and frequent bookings by other travelers. Find your next unforgettable adventure here.",
            all: "All",
            hasDiferencial: "Has diferencial",
            noReviews: "No reviews",
            viewAll: "View all packages",
        },
        aboutSection: {
            welcome: "Welcome to Portugalwaytour",
            title: "Explore beyond the horizon: discover the wonders of the world",
            description1: "At Portugal Way Tour, we believe traveling transforms. We are an agency specialized in unique tourist experiences in Portugal, committed to revealing the best of the country — its culture, landscapes, history, and authenticity.",
            point1: "Provide memorable trips with comfort, safety, and charm. We want every traveler to discover Portugal deeply, with itineraries blending tradition, nature, gastronomy, and genuine hospitality.",
            point2: "Be a reference for quality and trust in Portuguese tourism, recognized by tourists worldwide as a synonym of professionalism and delight.",
            learnMore: "Learn More",
            reviews: "{{count}}+ Reviews"
        },
        aboutCounters: [
            { label: "Destinations Worldwide", icon: "isax-global5", colorClass: "text-teal" },
            { label: "Bookings Completed", icon: "isax-calendar-2", colorClass: "text-purple" },
            { label: "Clients Globally", icon: "isax-tag-user5", colorClass: "text-pink" },
            { label: "Providers Registered", icon: "isax-status-up5", colorClass: "text-info" },
        ],
        expertSection: {
            popularTitle: "Popular",
            popularSubtitle: "Discover the most popular, highly rated, and frequently booked services by travelers.",
            serviceName: "Tuk Tuk Driver",
            loading: "Loading...",
            reservationsSingular: "reservation",
            reservationsPlural: "reservations",
            viewProfile: "View Profile",
            viewAll: "View All",
        },
        driverModal: {
            loading: "Loading...",
            description: "Description",
            languages: "Languages",
            vehicle: "Vehicle",
            seats: "seats",
            averageRating: "Average Rating",
            reviews: "Reviews",
            packages: "Packages",
            noReviews: "No reviews yet",
            noPackages: "This driver has no packages",
        },
        testimonialSection: {
            title: "What our {{highlight}} say",
            highlight: "users",
            subtitle: "Check out what our travelers thought about their experiences.",
            loading: "Loading reviews...",
            noReviews: "No reviews found.",
            noComment: "The user did not leave a comment.",
            viewPackage: "View package details"
        },
        updateSection: {
            faq: {
                title: "{{highlight}} Questions",
                highlight: "Frequently Asked",
                subtitle: "Portugalway, a tour operator specialized in dream destinations, offers a variety of benefits for travelers.",
                questions: [
                    {
                        question: "How do I book a tour?",
                        answer: "You can book directly on our website or contact us via email or phone. After defining the desired itinerary, we provide a quote, confirm hotels and services, and request payment according to the stated policy."
                    },
                    {
                        question: "Is it possible to customize the itinerary?",
                        answer: "Yes! All our itineraries are flexible. You choose the places you want to visit, the duration, the type of accommodation, and within the possibilities, we create something that fits your profile."
                    },
                    {
                        question: "What languages do the guides speak?",
                        answer: "We have guides who speak Portuguese, English, and, depending on the tour, other languages. Indicate your preferences when booking so we can assign the most suitable guide."
                    },
                    {
                        question: "What is the cancellation policy?",
                        answer: "We have a cancellation policy that varies depending on the tour, advance notice, and suppliers. At the time of booking, we provide the full terms. Please read carefully before confirming."
                    },
                    {
                        question: "What payment methods are accepted?",
                        answer: "We accept international bank transfer, credit card, and in some cases, other payment methods."
                    }
                ],
                contactUsText: "If you can't find the answer to your question in our Frequently Asked Questions, please contact us. We will reply shortly!",
                contactButton: "Contact Us",
            },
            support: {
                items: [
                    "Personalized Itineraries",
                    "Comprehensive Planning",
                    "Expert Guidance",
                    "Local Experience",
                    "Customer Support",
                    "Sustainability Efforts",
                    "Multiple Regions"
                ]
            }
        }
    },
    footer: {
        pages: {
            title: "Pages",
            settings: "Settings",
            profile: "Profile",
            social: "Social Network",
        },
        company: {
            title: "Company",
            about: "About Us",
            testimonials: "Testimonials",
            faq: "FAQ",
        },
        support: {
            title: "Support",
            contact: "Contact Us",
            privacy: "Privacy Policy",
            terms: "Terms & Conditions",
            chat: "Chat Support",
        },
        services: {
            title: "Services",
            tuktuk: "Tuk Tuk",
            winery: "Winery",
            restaurant: "Restaurant",
            car: "Car",
            hippotrip: "Hippotrip",
            bike: "Bike",
        },
        bottom: {
            copyright: "Copyright © 2025. All Rights Reserved,",
            brand: "Portugalwaytour",
            social: [
                { icon: "fa-brands fa-facebook", link: "#" },
                { icon: "fa-brands fa-x-twitter", link: "#" },
                { icon: "fa-brands fa-instagram", link: "#" },
                { icon: "fa-brands fa-linkedin", link: "#" },
                { icon: "fa-brands fa-pinterest", link: "#" },
            ],
            cards: [
                "assets/img/icons/card-01.svg",
                "assets/img/icons/card-02.svg",
                "assets/img/icons/card-03.svg",
                "assets/img/icons/card-04.svg",
                "assets/img/icons/card-05.svg",
                "assets/img/icons/card-06.svg",
            ],
        },
    },

    auth: {
        registerModal: {
            title: "Access your Account",
            subtitle: "Enter your email to log in or create an account",
            emailLabel: "Email",
            emailPlaceholder: "Enter your email",
            sendTestCode: "Send Test Code",
            sendEmailCode: "Send Email Code",
            codeLabel: "Verification Code",
            codePlaceholder: "Enter the code",
            verifyAndLogin: "Verify and Login",
            testCodeSuccess: "Test code '123456' generated. Use it to log in.",
            testCodeError: "Error generating test code.",
            emailSent: "Code sent to your email!",
            emailError: "Error sending code by email.",
            loginSuccess: "Login successful!",
            invalidCode: "Invalid or expired code.",
            or: "Or",
            google: "Google",
            facebook: "Facebook",
            reminderTitle: "Complete Your Profile",
            reminderText: "Don't forget to complete your profile to fully enjoy all features of the platform!",
            gotIt: "Got it",
        },
    },
    companyRegisterModal: {
        title: "Company Registration",
        step1: "Please enter your personal email to create an account for the company administrator. You will use this account to manage your company profile.",
        step2: "We’ve sent a verification code to your email. Please enter it below to verify your identity.",
        step3: "Now fill in your company’s details. The company email should be a corporate contact (e.g., info@company.com).",

        personalEmail: "Your personal email",
        sendTestCode: "Send test code",
        sendEmailCode: "Send code via email",

        verificationCode: "Verification Code",
        verifyCode: "Verify Code",

        companyEmail: "Company Email",
        companyName: "Company Name",
        nif: "Tax Identification Number (NIF)",
        nib: "Bank Account Number (NIB)",
        permanentCertificate: "Permanent Certificate Number",
        phone: "Phone Number",
        street: "Street Address",
        city: "City",
        postalCode: "Postal Code",
        country: "Country",
        companyDescription: "Brief Company Description",
        servicesProvided: "Services Provided",

        contractTitle: "Company Contract",
        acceptContract: "I accept the company contract",
        finishRegistration: "Finish Registration",

        messages: {
            "Test code sent successfully. Use '123456'.": "Test code sent successfully. Use '123456'.",
            "Verification email sent successfully.": "Verification email sent successfully.",
            "Verification successful.": "Verification successful.",
            "Company registered and contract accepted successfully!": "Company registered and contract accepted successfully!",
            testStepMessage: "Test code sent successfully. Use '123456'.",
            emailStepMessage: "A verification code has been sent to your email. Please enter it below."
        },

        errors: {
            "Failed to send the verification code.": "Failed to send the verification code.",
            "Invalid or expired code.": "Invalid or expired code.",
            "Please fill all required fields.": "Please fill all required fields.",
            "You must accept the contract to register the company.": "You must accept the contract to register the company.",
            "You must be logged in to register the company.": "You must be logged in to register the company.",
            "Failed to register the company or accept the contract.": "Failed to register the company or accept the contract."
        }
    },
    chooseUsSection: {
        title: "Why Choose Us?",
        cards: [
            {
                title: "Convenience",
                description: "Plan your entire trip from a single platform, saving time and effort. No more switching between different websites."
            },
            {
                title: "Best Price Guarantee",
                description: "We work with reliable travel partners to offer you the best deals, whether booking a flight, hotel, or car rental."
            },
            {
                title: "Customer Support",
                description: "Our dedicated support team is available 24/7, ensuring your travel plans run smoothly from start to finish."
            },
            {
                title: "Personalized Travel Experiences",
                description: "Whether traveling for business, family vacations, or a solo adventure, we provide options that cater to all needs."
            }
        ]
    },
    contactUsSection: {
        breadcrumb: {
            home: "Home",
            pages: "Pages",
            contactUs: "Contact Us"
        },
        title: "Get in touch with our dedicated support team",
        description: "Our team is ready to assist you. Your satisfaction is our priority.",
        info: [
            {
                label: "Email address",
                value: "portugaltourway@gmail.com"
            },
            {
                label: "Phone number",
                value: "INSERT NUMBER"
            },
            {
                label: "Our location",
                value: "INSERT STREET, Almada - Portugal"
            }
        ],
        supportCard: {
            title: "Need Support?",
            textLoggedOut: "To contact our support team and open tickets, you need to create an account or log in. After that, you'll have full access to your support dashboard, where you can track and manage your requests.",
            textLoggedIn: "You are already logged in! Now you can open a new support ticket or track existing tickets directly from your dashboard.",
            btnLoggedOut: "Create Account / Log In",
            btnLoggedIn: "Open Ticket in Dashboard"
        }
    },

    sidebar: {
        main: "Main",
        dashboard: "Dashboard",
        myBookings: "My Bookings",
        myReviews: "My Reviews",
        wishlist: "Wishlist",
        support: "Support",
        finance: "Finance",
        wallet: "Wallet",
        payments: "Payments",
        account: "Account",
        myProfile: "My Profile",
        notifications: "Notifications",
        settings: "Settings",
        preferences: "Preferences",
        logout: "Logout",
    },

    agentSidebar: {
        dashboard: "Dashboard",
        bookings: "Bookings",
        tukTukBookings: "Tuk Tuk Bookings",
        hotelBookings: "Hotel Bookings",
        carBookings: "Car Bookings",
        cruiseBookings: "Cruise Bookings",
        tourBookings: "Tour Bookings",
        flightBookings: "Flight Bookings",
        enquiries: "Enquiries",
        earnings: "Earnings",
        reviews: "Reviews",
        support: "Support",
        serviceEnrollment: "Service Enrollment",
        drivers: "Drivers",
        tukTukVehicles: "Tuk Tuk Vehicles",
        settings: "Settings",
        logout: "Logout",
    },

    dashboardCards: {
        totalBookings: "Total Packages Purchased",
        totalListings: "Total Packages",
        totalEarnings: "Total Earnings",
        totalReviews: "Total Reviews",
    },

    recentlyadded: {
        titulo: "Recently Added",
    },

    BookingsStatistics: {
        titulo: "Bookings Statistics",
        loading: "Loading statistics...",
        none: "No reservations registered yet.",
    },

};
